import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const date_format = 'DD-MM-YYYY';
export const datetime_format = 'DD-MM-YYYY h:mm a';
export const datetime_seconds_format = 'DD-MM-YYYY h:mm:ss a';
export const nz_date_format = 'dd-MM-yyyy';
export const nz_datetime_format = 'dd-MM-YYYY HH:mm';
export const date_format_html = 'DD-MM-YYYY';

// export const date_format = 'MM-DD-YYYY';
// export const datetime_format = 'MM-DD-YYYY h:mm a';
// export const datetime_seconds_format = 'MM-DD-YYYY h:mm:ss a';
// export const nz_date_format = 'MM-dd-YYYY';
// export const nz_datetime_format = 'MM-dd-YYYY HH:mm';
// export const date_format_html = 'MM-DD-YYYY';

// export const date_format = 'YYYY-MM-DD';
// export const datetime_format = 'YYYY-MM-DD h:mm a';
// export const datetime_seconds_format = 'YYYY-MM-DD h:mm:ss a';
// export const nz_date_format = 'YYYY-MM-dd';
// export const nz_datetime_format = 'YYYY-MM-dd HH:mm';
// export const date_format_html = 'YYYY-MM-dd';

export function dateRangeValidator(
  min?: Date | string,
  max?: Date | string
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null; // required validator handles empty input
    }

    const value = new Date(control.value);
    if (isNaN(value.getTime())) {
      return { invalidDate: true };
    }

    const current = new Date(
      value.getFullYear(),
      value.getMonth(),
      value.getDate()
    );

    // Min date check
    if (min && min !== '') {
      const minDate =
        min instanceof Date
          ? new Date(min.getFullYear(), min.getMonth(), min.getDate())
          : new Date(min);

      if (!isNaN(minDate.getTime()) && current < minDate) {
        return { minDate: { required: minDate, actual: current } };
      }
    }

    // Max date check
    if (max && max !== '') {
      const maxDate =
        max instanceof Date
          ? new Date(max.getFullYear(), max.getMonth(), max.getDate())
          : new Date(max);

      if (!isNaN(maxDate.getTime()) && current > maxDate) {
        return { maxDate: { required: maxDate, actual: current } };
      }
    }

    return null;
  };
}

export function dynamicDateRangeValidator(
  getMin?: () => Date | string | undefined,
  getMax?: () => Date | string | undefined
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;

    const value = new Date(control.value);
    if (isNaN(value.getTime())) return { invalidDate: true };

    const current = new Date(
      value.getFullYear(),
      value.getMonth(),
      value.getDate()
    );

    const minVal = getMin ? getMin() : undefined;
    const maxVal = getMax ? getMax() : undefined;

    if (minVal) {
      const minDate = minVal instanceof Date ? minVal : new Date(minVal);
      if (!isNaN(minDate.getTime()) && daysDiff(current, minDate) < 0) {
        return { minDate: { required: minDate, actual: current } };
      }
    }

    if (maxVal) {
      const maxDate = maxVal instanceof Date ? maxVal : new Date(maxVal);
      if (!isNaN(maxDate.getTime()) && daysDiff(current, maxDate) > 0) {
        return { maxDate: { required: maxDate, actual: current } };
      }
    }

    return null;
  };
}

const daysDiff = (a: Date, b: Date) => {
  const msPerDay = 1000 * 60 * 60 * 24;
  const aMid = new Date(a.getFullYear(), a.getMonth(), a.getDate());
  const bMid = new Date(b.getFullYear(), b.getMonth(), b.getDate());
  return Math.round((aMid.getTime() - bMid.getTime()) / msPerDay);
};
